const getVisibleSlides = (propsSwiper) => {
    if (typeof window === 'undefined') {
        return Math.floor(propsSwiper.slidesPerView);
    }

    const breakpoints = Object.entries(propsSwiper.breakpoints);

    const breakPointIndex = breakpoints.reverse().findIndex((element) => element[0] <= window.innerWidth);

    return breakPointIndex < 0
        ? Math.floor(propsSwiper.slidesPerView) * 2
        : Math.floor(propsSwiper.breakpoints[breakpoints[breakPointIndex][0]].slidesPerView) * 2;
};

export { getVisibleSlides };
